
export class ChoiceOption {
public Label: string;
public Value: string;
public Default: boolean;
}

function ChoiceOption_tsickle_Closure_declarations() {
/** @type {?} */
ChoiceOption.prototype.Label;
/** @type {?} */
ChoiceOption.prototype.Value;
/** @type {?} */
ChoiceOption.prototype.Default;
}

